var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('map-base',{ref:"mapBase",style:({ zIndex: 0 }),attrs:{"showGeoSearchControl":false}})}
var staticRenderFns = []

export { render, staticRenderFns }